<template>
  <section class="bg-[#f6f6f6] py-10 px-4">

    <section class="py-10 text-center">
    <div class="max-w-4xl mx-auto px-4" v-if="planoSelecionado">
      <h2 class="text-2xl sm:text-3xl font-bold text-gray-800">
        VOCÊ ADICIONOU O PLANO
        <span class="bg-[#ff5f76] text-white px-3 py-1 rounded-sm inline-block">
          {{ planoSelecionado.nome }}
        </span>
      </h2>
      <p class="text-gray-600 mt-4 text-sm sm:text-base">
        VPS + Painel de controle cPanel/WHM + Painéis exclusivos Integrator Java EE, Node.js e Spring Boot.
      </p>
    </div>
  </section>

  
    <div class="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-8">
      <!-- FORMULÁRIOS -->
      <div class="lg:col-span-2 space-y-6">
  
       
        <!-- DOMÍNIO -->
        <div class="bg-white rounded-md shadow p-6 border-t-2 border-grey-500">
        <h2 class="text-lg font-bold text-[#f94368] mb-4">Seu Domínio</h2>

        <!-- Input e botão de verificação -->
        <!-- Linha com input + botão -->
        <div class="flex gap-2 items-start mb-1">
        <div class="w-full">
          <input
            type="text"
            v-model="dominio"
            :disabled="tipoDominio === 'subdominio'"
            placeholder="Digite o domínio (ex: meusite.com)"
            class="border border-gray-300 rounded px-3 py-2 w-full"
          />
          <!-- Erro abaixo do input -->
          <p v-if="erroDominio" class="bg-red-500 text-white text-sm rounded px-3 py-1 mt-1  inline-block">
            {{ erroDominio }}
          </p>
        </div>

        <!-- Botão só aparece se o tipoDominio for 'registro' -->
        <button
          v-if="tipoDominio === 'registro'"
          @click="handleVerificarDominio"
          class="bg-[#f94368] text-white px-4 py-2 rounded h-[42px]"
        >
          Verificar
        </button>
        </div>


        <p v-if="carregando" class="text-sm text-gray-500">Verificando...</p>
        <p v-if="resultado" class="text-sm font-semibold mt-1">{{ resultado }}</p>

        <!-- Opções de domínio -->
        <div class="space-y-2 text-sm text-gray-700 mt-4">
          <div>
            <input type="radio" id="registro" value="registro" v-model="tipoDominio" />
            <label for="registro"> Sim, desejo que a Integrator registre o domínio...</label>
          </div>
          <div>
            <input type="radio" id="ja-tenho" value="ja-tenho" v-model="tipoDominio" />
            <label for="ja-tenho"> Não, já tenho um domínio registrado.</label>
          </div>
          <div>
            <input type="radio" id="subdominio" value="subdominio" v-model="tipoDominio" />
            <label for="subdominio"> Quero um subdomínio grátis (seunome.integrator.host)</label>
          </div>
        </div>
        </div>


      <div class="bg-white rounded-md shadow p-6 border-t-2 border-grey-500">
        <h2 class="text-lg font-bold text-[#f94368] mb-4">Endereço de E-mail</h2>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">

            <div class="col-span-2">
            <input
                type="email"
                v-model="emailPrincipal"
                placeholder="E-mail Principal"
                class="input"
                
            />
            <div v-if="erroEmailPrincipal === 'Bem-vindo! Este e-mail ainda não está cadastrado. Por favor, continue com seu cadastro.'" 
                class="bg-green-500 text-white text-sm rounded px-3 py-1 mt-1 inline-block">
              {{ erroEmailPrincipal }}
            </div>
            <div v-else-if="erroEmailPrincipal" 
                class="bg-red-500 text-white text-sm rounded px-3 py-1 mt-1 inline-block">
              {{ erroEmailPrincipal }}
            </div>
            
            </div>

        </div>
        </div>


        <!-- INFOS ASSINANTE -->
        <div class="bg-white rounded-md shadow p-6 border-t-2 border-grey-500">
          <h2 class="text-lg font-bold text-[#f94368] mb-4">Informações do Assinante</h2>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <input type="text" v-model="cpfCnpj" @blur="handleValidarCpfCnpj" placeholder="CPF ou CNPJ" class="input" />
              <p v-if="erroCpfCnpj" class="bg-red-500 text-white text-sm rounded px-3 py-1 mt-1 inline-block">{{ erroCpfCnpj }}</p>
            </div>
            <div class="col-span-2">
              <input
                type="text"
                v-model="nomeEmpresa"
                @input="nomeEmpresa = $event.target.value.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ\s]/g, '')"
                placeholder="Nome do Responsável ou Empresa"
                class="input"
              />
              <p v-if="erroNomeEmpresa" class="bg-red-500 text-white text-sm rounded px-3 py-1 mt-1 inline-block">
                {{ erroNomeEmpresa }}
              </p>
            </div>
            <input type="email" v-model="emailAlternativo" placeholder="E-mail Alternativo (opcional)" class="input" />

            <input type="text"  v-model="telefone"  placeholder="Celular ou WhatsApp (opcional)" class="input" />

          </div>
        </div>

        <!-- ENDEREÇO -->
        <div class="bg-white rounded-md shadow p-6 border-t-2 border-grey-500">
          <h2 class="text-lg font-bold text-[#f94368] mb-4">Endereço</h2>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">

            <div>
              <input
                type="text"
                v-model="cep"
                @input="cep = cep.replace(/\D/g, '').slice(0, 8)"
                @blur="handleBuscarEndereco"
                placeholder="CEP"
                class="input"
              />
              <p v-if="erroCep" class="bg-red-500 text-white text-sm rounded px-3 py-1 mt-1 inline-block">
                {{ erroCep }}
              </p>
            </div>
            
          </div>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          
              <input type="text" v-model="endereco" placeholder="Endereço" class="input col-span-3" />
              <p v-if="erroEndereco" class="bg-red-500 text-white text-sm rounded px-3 py-1 mt-1 inline-block">{{ erroEndereco }}</p>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <input type="text" v-model="estado" placeholder="Estado" class="input" />
              <p v-if="erroEstado" class="bg-red-500 text-white text-sm rounded px-3 py-1 mt-1 inline-block">{{ erroEstado }}</p>
            </div>
            <div>
              <input type="text" v-model="cidade" placeholder="Cidade" class="input" />
              <p v-if="erroCidade" class="bg-red-500 text-white text-sm rounded px-3 py-1 mt-1 inline-block">{{ erroCidade }}</p>
            </div>
            <div>
              <input type="text" v-model="bairro" placeholder="Bairro" class="input" />
              <p v-if="erroBairro" class="bg-red-500 text-white text-sm rounded px-3 py-1 mt-1 inline-block">{{ erroBairro }}</p>
            </div>
          </div>
        </div>

        <!-- INFO OPCIONAL -->
        <div class="bg-white rounded-md shadow p-6 border-t-2 border-grey-500">
          <h2 class="text-lg font-bold text-[#f94368] mb-4">Como você conheceu a nossa empresa?</h2>
          <div class="mb-4">
            <label class="text-sm block mb-1">Como ficou sabendo da Integrator?</label>
            <select class="input" v-model="indicacao">
              <option>Selecione uma Opção</option>
              <option>Google</option>
              <option>Indicação</option>
              <option>Instagram</option>
              <option>Facebook</option>
              <option>Youtube</option>
              <option>Parceiros</option>
            </select>
          </div>
          <textarea class="input min-h-[100px]"  v-model="infoAdicional" placeholder="Informações adicionais"></textarea>
        </div>
      </div>

          <!-- LADO DIREITO -->
      <div class="lg:col-span-1 space-y-6">
        <div class="bg-white rounded-md shadow p-6 border-t-2 border-grey-500" v-if="planoSelecionado">
        <h3 class="text-sm font-bold text-gray-600 mb-4">DESCRIÇÃO DO PLANO</h3>
        <div class="text-sm text-gray-800">
          <p class="font-bold text-xl mb-1">PLANO {{ planoSelecionado.nome }}</p>
          <p class="mb-4 mt-4"><strong>Recursos:</strong></p>
          <ul class="list-disc list-inside text-xs space-y-1">
            <li>CPU: {{ planoSelecionado.processamento }} vCore @ Intel Xeon 3.5Ghz</li>
            <li>Espaço Disco: {{ planoSelecionado.disco }} GB de SSD</li>
            <li>Memória: {{ planoSelecionado.ram1 }} GB de RAM</li>
            <li>Tráfego: Ilimitado</li>
            <li>IP Dedicado: 2</li>
          </ul>
          <ul class="list-disc list-inside text-xs space-y-1">
            <p class="mb-3 mt-4"><strong>Painel de Controle:</strong></p>
            <li>WHM e cPanel</li>
            <li>Contas cPanel: {{ planoSelecionado.dominios }}</li>
            <li>Integrator Java EE</li>
            <li>Integrator Node.js</li>
            <li>Integrator Spring Boot</li>
            <li>Integrator Https</li>
            <li>Integrator Custom Erro</li>
          </ul>
          <ul class="list-disc list-inside text-xs space-y-1">
            <p class="mb-3 mt-4"><strong>Tecnologia</strong></p>  
            <li>{{ planoSelecionado.tecnologia }}</li>
          </ul>
          <ul class="list-disc list-inside text-xs space-y-1">
            <p class="mb-4 mt-4"><strong>Banco de Dados</strong></p>    
            <li>{{ planoSelecionado.banco }}</li>
          </ul>
          <ul class="list-disc list-inside text-xs space-y-1">
            <p class="mb-3 mt-4"><strong>Domínios</strong></p>    
            <li>Domínios: Ilimitados</li>
            <li>Subdomínios: {{ planoSelecionado.subdominios }}</li>
            <li>SSL Incluso em todos</li>
          </ul>
          <ul class="list-disc list-inside text-xs space-y-1">
            <p class="mb-3 mt-4"><strong>E-mails</strong></p>    
            <li>Caixas de E-mail: {{ planoSelecionado.emails }}</li>
            <li>Tamanho da Caixa: Flexível</li>
          </ul>
          <ul class="list-disc list-inside text-xs space-y-1">
            <p class="mb-3 mt-4"><strong>Sistema Operacional</strong></p> 
            <li>Almalinux 9</li>
          </ul>
          <ul class="list-disc list-inside text-xs space-y-1">
            <p class="mb-3 mt-4"><strong>Outros</strong></p> 
            <li>Anti-DDoS Incluso</li>
            <li>Antivirus</li>
            <li>Instalador Automático: WordPress + 382 scripts</li>
          </ul>
        </div>
      </div>

      <div class="bg-white rounded-md shadow p-6 space-y-4 border-t-2 border-grey-500">
        <div>
          <p class="text-[#f94368] text-xs font-bold mb-1">CUPOM DE DESCONTO</p>
          <div class="flex gap-2">
          <input type="text" v-model="cupom" class="input" placeholder="Digite o código" />
          <button @click="handleAplicaCupom" class="bg-[#f94368] text-white px-4 rounded">Aplicar</button>
          </div>
          <p v-if="erroCupom" class="text-red-500 text-xs mt-1">{{ erroCupom }}</p>
          <p v-if="cupomValido" class="text-green-600 text-xs mt-1">Cupom aplicado com sucesso!</p>
        </div>

        <div>
          <p class="text-[#f94368] text-xs font-bold mb-1">PERÍODO PAGAMENTO</p>
          <select v-model="periodoSelecionado" class="input">
              <option value="1">Mensal</option>
              <option value="6">Semestral</option>
              <option value="12">Anual</option>
          </select>
        </div>

        <div>
          <p class="text-sm text-gray-500 mb-1 mt-10">VALOR TOTAL ( {{ periodoSelecionado }} {{ periodoSelecionado == 1 ? 'MÊS' : 'MESES' }} )</p>
          <p class="text-4xl font-bold text-[#f94368]">R$ {{ valorTotalCalculado }}</p>

        </div>

        <div>
       
     
            <p v-if="erroCaptcha" class="text-red-500 text-xs mt-1">{{ erroCaptcha }}</p>

        </div>

        <button @click.prevent="handleAssinar" class="w-full bg-[#f94368] text-white py-3 rounded-full font-bold mt-2">
          ASSINE JÁ
        </button>
      </div>

      
    </div>
  </div>
</section>
</template>




<script setup>
import { ref, watch, onMounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import axios from '@/services/api'

import aplicarCupom from '@/components/assineja/js/aplicarCupom'
import validarFormulario from '@/components/assineja/js/validarFormulario'
import validarCpfCnpj from '@/components/assineja/js/validarCpfCnpj'
import buscarEndereco from '@/components/assineja/js/buscarEndereco'
import buscarClientePorEmail from '@/components/assineja/js/buscarClientePorEmail'
import verificarDominio from '@/components/assineja/js/verificarDominio'
import calcularValorTotal from '@/components/assineja/js/calcularValorTotal_1_6_12'
import enviarAssinatura from '@/components/assineja/js/enviarAssinaturaVpsCpanel'

const nomeEmpresa = ref('')
const cpfCnpj = ref('')
const cep = ref('')
const endereco = ref('')
const estado = ref('')
const cidade = ref('')
const bairro = ref('')
const telefone = ref('')
const numero = ref('')
const complemento = ref('')
const emailPrincipal = ref('')
const emailAlternativo = ref('')
const dominio = ref('')
const tipoDominio = ref('subdominio')
const erroDominio = ref('')
const planoSelecionado = ref(null)
const periodoSelecionado = ref('1')
const cupom = ref('')
const cupomValido = ref(null)
const erroCupom = ref('')
const resultado = ref('')
const indicacao = ref('')
const infoAdicional = ref('')
const carregando = ref(false)
const erroEmailPrincipal = ref('')
const erroNomeEmpresa = ref('')
const erroCpfCnpj = ref('')
const erroCep = ref('')
const erroEndereco = ref('')
const erroEstado = ref('')
const erroCidade = ref('')
const erroBairro = ref('')
const captchaToken = ref('')
const erroCaptcha = ref('')
const route = useRoute()
const router = useRouter()
const planoId = route.query.planoId

const refs = {
  cpfCnpj,
  nomeEmpresa,
  cep,
  endereco,
  cidade,
  estado,
  bairro,
  telefone,
  emailAlternativo,
  numero,
  complemento,
  erroEmailPrincipal
}

const handleVerificarDominio = () => {
  verificarDominio({ dominio, resultado, carregando })
}

const handleBuscarCliente = () => {
  buscarClientePorEmail(emailPrincipal, refs)
}

const handleValidarCpfCnpj = () => {
  validarCpfCnpj(cpfCnpj, erroCpfCnpj, nomeEmpresa, erroNomeEmpresa)
}

const handleBuscarEndereco = () => {
  buscarEndereco(cep, endereco, bairro, cidade, estado, erroCep)
}

const handleAplicaCupom = () => {
  aplicarCupom(cupom, planoSelecionado, erroCupom, cupomValido)
}

const valorTotalCalculado = computed(() => {
  const valor = calcularValorTotal(planoSelecionado.value, periodoSelecionado.value, cupomValido.value)
  return valor.toFixed(2).replace('.', ',')
})

const esperarCarregarGrecaptcha = () =>
  new Promise((resolve) => {
    const checar = () => {
      if (window.grecaptcha && grecaptcha.execute) {
        resolve()
      } else {
        setTimeout(checar, 200)
      }
    }
    checar()
  })

onMounted(() => {
  window.onCaptchaVerified = function (token) {
    captchaToken.value = token
    erroCaptcha.value = ''
  }
})


watch(tipoDominio, (novoValor) => {
  if (novoValor !== 'registro') {
    resultado.value = ''
    dominio.value = ''
    erroDominio.value = ''
  }
})

onMounted(async () => {
  if (planoId) {
    try {
      const response = await axios.get(`/api/planos/buscar/${planoId}`)
      planoSelecionado.value = response.data
    } catch (e) {
      console.error('Erro ao buscar plano:', e)
    }
  }
})

const handleAssinar = async () => {
  console.log('Clicou em assinar!')

  // Validação do formulário antes do reCAPTCHA
  const valido = await validarFormulario({
    nomeEmpresa,
    cpfCnpj,
    cep,
    endereco,
    estado,
    cidade,
    bairro,
    telefone,
    emailPrincipal,
    emailAlternativo,
    numero,
    complemento,
    dominio,
    tipoDominio,
    erroDominio,
    erroEmailPrincipal,
    erroNomeEmpresa,
    erroCpfCnpj,
    erroCep,
    erroEndereco,
    erroEstado,
    erroCidade,
    erroBairro,
    planoSelecionado,
    cupom,
    indicacao,
    infoAdicional,
    cupomValido
  })

  if (!valido) return

  try {
    await esperarCarregarGrecaptcha()
    const token = await grecaptcha.execute('6LfN6BkrAAAAAODM9tps1UyKv-BDg5aF3zK0_y3g', { action: 'submit' })

    if (!token) {
      erroCaptcha.value = 'Erro ao gerar token do reCAPTCHA.'
      return
    }

    captchaToken.value = token

    await enviarAssinatura({
      nomeEmpresa,
      emailPrincipal,
      emailAlternativo,
      cpfCnpj,
      cep,
      endereco,
      complemento,
      estado,
      cidade,
      bairro,
      telefone,
      numero,
      dominio,
      tipoDominio,
      planoSelecionado,
      periodoSelecionado,
      cupom,
      indicacao,
      infoAdicional,
      calcularValorTotal,
      cupomValido,
      captchaToken: captchaToken.value,
      router
    })
  } catch (e) {
    erroCaptcha.value = 'Erro ao validar reCAPTCHA. Tente novamente.'
    console.error('Erro no reCAPTCHA:', e)
  }
}


</script>

<style scoped>
.input {
  @apply border border-gray-300 rounded px-3 py-2 w-full;
}
input[type='radio'] {
  accent-color: #f94368;
}
button:disabled,
input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>